var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNodlesGreyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6 12C15.8209 12 16 12.1791 16 12.4L16 15.6C16 15.8209 15.8209 16 15.6 16L12.4 16C12.1791 16 12 15.8209 12 15.6L12 12.4C12 12.1791 12.1791 12 12.4 12L13.5 12L13.5 8.26191L8.5 8.26191L8.5 12L9.6 12C9.82091 12 10 12.1791 10 12.4L10 15.6C10 15.8209 9.82091 16 9.6 16L6.4 16C6.17909 16 6 15.8209 6 15.6L6 12.4C6 12.1791 6.17909 12 6.4 12L7.5 12L7.5 8.26191L2.5 8.26191L2.5 12L3.6 12C3.82091 12 4 12.1791 4 12.4L4 15.6C4 15.8209 3.82091 16 3.6 16L0.399998 16C0.179084 16 -6.91554e-07 15.8209 -6.81898e-07 15.6L-5.42021e-07 12.4C-5.32365e-07 12.1791 0.179084 12 0.399998 12L1.5 12L1.5 7.2619L7.5 7.2619L7.5 4L6.4 4C6.17908 4 6 3.82092 6 3.6L6 0.400001C6 0.179087 6.17908 2.70096e-07 6.4 2.79753e-07L9.6 4.19629e-07C9.82091 4.29285e-07 10 0.179087 10 0.400001L10 3.6C10 3.82092 9.82091 4 9.6 4L8.5 4L8.5 7.2619L14.5 7.26191L14.5 12L15.6 12Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodlesGreyIcon);
export default __webpack_public_path__ + "static/media/NodlesGreyIcon.a778b733.svg";
export { ForwardRef as ReactComponent };